import { EventEmitter, Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Breakpoint } from '@icilalune/utils/responsive';

interface GeoLoc {
  lon: number;
  lat: number;
}

export type TunnelStoreContext = 'home' | 'list' | 'detail' | 'odyssee';

interface TunnelStore {
  showStats: boolean;
  ratio: number;
  index: number;
  isHome: boolean;
  geoLoc?: GeoLoc;
  context?: TunnelStoreContext;
  breakpoint?: Breakpoint;
  earthReady: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class TunnelService extends ComponentStore<TunnelStore> {
  readonly showStats$ = this.select((s) => s.showStats);
  readonly ratio$ = this.select((s) => s.ratio);
  readonly index$ = this.select((s) => s.index);
  readonly isHome$ = this.select((s) => s.isHome);
  readonly geoLoc$ = this.select((s) => s.geoLoc);
  readonly context$ = this.select((s) => s.context);
  readonly breakpoint$ = this.select((s) => s.breakpoint);
  readonly earthReady$ = this.select((s) => s.earthReady);

  renderEmitter: EventEmitter<any> = new EventEmitter<any>();

  cityTravelEndEmitter: EventEmitter<any> = new EventEmitter<any>();

  set showStats(showStats: boolean) {
    this.patchState({ showStats });
  }

  get showStats(): boolean {
    return this.get((s) => s.isHome);
  }

  set ratio(ratio: number) {
    this.patchState({ ratio });
  }

  get ratio(): number {
    return this.get((s) => s.ratio);
  }

  set index(index: number) {
    this.patchState({ index });
  }

  get index(): number {
    return this.get((s) => s.index);
  }

  set isHome(isHome: boolean) {
    this.patchState({ isHome });
  }

  get isHome(): boolean {
    return this.get((s) => s.isHome);
  }

  set geoLoc(geoLoc: GeoLoc | undefined) {
    this.patchState({ geoLoc });
  }

  get geoLoc(): GeoLoc | undefined {
    return this.get((s) => s.geoLoc);
  }

  set context(context: TunnelStoreContext | undefined) {
    this.patchState({ context });
  }

  get context(): TunnelStoreContext | undefined {
    return this.get((s) => s.context);
  }

  set breakpoint(breakpoint: Breakpoint | undefined) {
    this.patchState({ breakpoint });
  }

  get breakpoint(): Breakpoint | undefined {
    return this.get((s) => s.breakpoint);
  }

  set earthReady(earthReady: boolean) {
    this.patchState({ earthReady });
  }

  get earthReady(): boolean {
    return this.get((s) => s.earthReady);
  }

  render() {
    this.renderEmitter.emit();
  }

  constructor() {
    super({
      showStats: false,
      ratio: 0,
      index: 0,
      isHome: false,
      context: 'home',
      geoLoc: { lat: 48.866666666667, lon: 2.3333333333333 },
      earthReady: false,
    });
  }
}
